// eslint-disable-next-line import/no-cycle
import config from '../../config'
import * as Tracker from '../Tracker'

export function getUserInfo(userInfoKey) {
  const json = window.localStorage.getItem(userInfoKey || config.USER_INFO_KEY)
  if (json) {
    try {
      return JSON.parse(json)
    } catch (ex) {
      removeUserInfo()
    }
  }
  return null
}

export function removeUserInfo(isBackofficeWebsite) {
  const userInfoKey = isBackofficeWebsite
    ? 'BACKOFFICE_' + config.USER_INFO_KEY
    : config.USER_INFO_KEY

  window.localStorage.removeItem(userInfoKey)
  Tracker.reset()
}

export function getUserName() {
  const userInfo = getUserInfo()

  return userInfo?.user?.username
}

export function getFirstName() {
  const userInfo = getUserInfo()

  return userInfo?.user?.firstName
}

export function getLastName() {
  const userInfo = getUserInfo()

  return userInfo?.user?.lastName
}

export function getCustomerId() {
  const userInfo = getUserInfo()

  return userInfo?.customer?.id
}

export function getCustomerName() {
  const userInfo = getUserInfo()

  return userInfo?.customer?.name
}

export function getUserAliasId() {
  const userInfo = getUserInfo()

  return userInfo?.user?.id
}

export function getTempUserLogoutTime() {
  const userInfo = getUserInfo()

  return userInfo?.tempUser?.logoutTime
}

export function getTempUserWscWorkerId() {
  const userInfo = getUserInfo()

  return userInfo?.tempUser?.wscWorkerId
}
